module.exports = __webpack_public_path__ + "static/media/next_challenges_bitcoin-studio.cb8b8f65.jpg";